import React, { Component } from "react";
import { Radio } from "antd";

export default class RadioCustom extends Component {
	onChange = e => {
		this.props.setFieldValue(this.props.name, e.target.value);
	};

	render() {
		const { data } = this.props;
		const RadioButton = Radio.Button;
		const RadioGroup = Radio.Group;

		return (
			<div>
				<div>
					<RadioGroup onChange={this.onChange}>
						{data.map((val, i) => (
							<RadioButton key={i} value={val.value}>
								{val.label}
							</RadioButton>
						))}
					</RadioGroup>
				</div>
			</div>
		);
	}
}
